import { useTheme } from "@emotion/react";
import { useContext } from "react";

import { useThemeProps } from "../../wsui/base";

import PostCardController from "./PostCardController.jsx";
import postsModuleContext from "./postsModuleContext";

export default function PostsModuleCardItem(props) {
  // eslint-disable-next-line no-unused-vars
  const theme = useTheme();
  props = useThemeProps({ props, name: "MunicipioPostsModuleCardItem" });
  let { item, visibleFields, ...restProps } = props;

  if (Array.isArray(visibleFields)) {
    visibleFields = visibleFields.reduce((acc, field) => {
      acc[field] = true;
      return acc;
    }, {});
  }

  let link = item.link;
  let cta = link?.title ? link : null;
  link = cta ? null : link;

  const { itemColor, excerptLines } = useContext(postsModuleContext);

  let post = {
    ...item,
    postType: item.contentType,
    link,
    cta,
  };

  return (
    <PostCardController
      post={post}
      visibleFields={visibleFields}
      color={!item.color || item.color === "auto" ? itemColor : item.color}
      excerptLines={excerptLines}
      {...restProps}
    />
  );
}
